import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { ChemistryRow } from "../models/ChemistryRow";

type getChemistryResultsProps = {
	heatId?: number | null;
	supplierId?: number | null;
	gradeId?: number | null;
	startDate?: Date | null;
	endDate?: Date | null;
};

export const getChemistryResults = async (
	params: getChemistryResultsProps = {},
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "HeatId", value: params.heatId ?? null },
		{ name: "SupplierId", value: params.supplierId ?? null },
		{ name: "GradeId", value: params.gradeId ?? null },
		{ name: "StartDate", value: params.startDate?.toISOString() ?? null },
		{ name: "EndDate", value: params.endDate?.toISOString() ?? null },
	];

	const resp = await apiService.callV2(
		"[LAB].[GetChemistryResults]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as ChemistryRow[];
	} else {
		throw new Error(resp.message || "Error fetching chemistry results");
	}
};
